import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { login } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { userProfile } from "../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { toast } from "react-toastify";
import EmailInput from "../../common/components/form/EmailInput.Component";
import PasswordInput from "../../common/components/form/PasswordInput.Component";
import { RotatingLines } from "react-loader-spinner";
import { settings } from "../../redux/settings/actions";

export default function MentorLogin() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
    const [baseURL, setBaseUrl] = useState('');

    const [loginValues, setLoginValues] = useState<any>()
    const [colorTheme, setTheme] = useDarkMode();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [darkSide, setDarkSide] = useState(
        colorTheme === "light" ? true : false
    );
    const [steps, setSteps] = useState({ Email: '', Password: '' })


    const handleSteps = (e: any, key: any) => {
        setSteps({ ...steps, [key]: e.target.value })
    }

    const toggleDarkMode = (checked: any) => {
        setTheme(colorTheme);
        setDarkSide(checked);
    };

    const handleChange: any = (event: any, field: string) => {
        setLoginValues({ ...loginValues, [field]: event })
    }

    const gotoHome = async (role: any) => {
        switch (role?.toLowerCase()) {
            case 'mentor':
                navigate("/mentor/home")
                break;
            default:
                navigate("/")
        }
    }
    const handleRegistration = () => {
        dispatch(settings.set({ getRegistry: 'open' }))
        navigate('/mentor/register')
    };
    const handleForgotPassword = (e: any) => {
        e.preventDefault();
        storePersist.set('reset-pwd', 'management')
        navigate('/login/forgot-password')
    }

    const onFinish = async () => {
        setIsLoading(true)
        try{					
            const metaData: any = storePersist.get("metaTokenMetaData");

            console.log('metaData', metaData)
            await dispatch(login({
                loginData: {
                    "Records": [
                        {
                            "Context": {
                                "Subscription": "ONE",
                                "Domain": "ONE",
                                "SubDomains": [],
                                "Network": "Mentor",
                                "Application": "Mentor",
                                "Channel": "CSP"
                              },
                            "Message": {
                                "Username": steps?.Email,
                                "Password": steps?.Password,
                                "AccountType": "Mentor",
                                "LoginWithOtp": false,
                                "Otp": "",
                                "IsGoogleAuthenticated": false,
                                "AuthenticatedUserId": "",
                                "ClientIPAddress": "",
                                "OrganizationUnitId": metaData?.current?.items?.Website?.OUId
                            }
                        }
                    ]

                }
            }))
                const resp = await dispatch(userProfile.read({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`, entity: 'userProfile' }))
                // const userRole: any = await getAccountTypeChannalName();
                // console.log('userRole', userRole)
                // const roleData = await userRole?.role.find((roleName: any) => roleName === 'BusinessOwner');
                // console.log('roleData', roleData)
                let selectedRole = ''
                console.log('management resp', resp)
                const targetRoles = ['mentor']; // Roles to match
                resp.find((element: any) => 
                    element?.Message?.Roles.find((role: any) => {
                        if (targetRoles.includes(role?.Name?.toLowerCase())) {
                            selectedRole = role.Name.toLowerCase();
                            return true;
                        }
                        return false;
                    })
                );	
               		
                await gotoHome(selectedRole);	
        } catch (e: any) {
            toast.error(e?.Error?.Message || 'There was an error in login. Please try again...')
            // toast.error('There was an error in login. Please try again...')
            console.error('Login failed:', e?.Error?.Message);
        }
        setIsLoading(false)
    };

    const startGoogleAuthentication = () => {
        // const token = storePersist.get('guest-token');  
        storePersist.set('google-login-role', 'businessowner')
        const guestToken = localStorage.getItem("guest-token");
        console.log('startGoogleAuthentication token', guestToken)
        const url = `${process.env.REACT_APP_IDENTITY_SERVER_URL}/googleauth/SignInWithGoogle?guest_token=${guestToken}&ClientRedirectUrl=${baseURL}`
        console.log('url', url)
        // navigate(url)
        window.location.href = url;
    }

    useEffect(() => {
        setBaseUrl(window.location.origin);
        clearErrors('Email')
        clearErrors('Password')
    }, [])

    return (
        <>
        
        <form onSubmit={handleSubmit(onFinish)} >
            <div className="flex h-screen bg-[#F8F8F8]">
                <div className="container mx-auto px-4 ">
                    <div className="flex content-center items-center justify-start h-full">
                        <div className="w-1/2 h-max px-6">
                            <div className="bg-white flex flex-col items-end justify-around h-full">
                                <div className="flex flex-col justify-center w-full h-screen px-4 px-3">
                                    <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">
                                    Mentor Portal Login
                                        <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                                    </div>
                                    <div className="w-full my-5">
                                        <EmailInput
                                            label="Email Address"
                                            name="Email"
                                            isRequired={true}
                                            register={register}
                                            errors={errors}
                                            setValue={setValue}
                                            handleSteps={(e) => handleSteps(e, 'Email')} 
                                        />
                                    </div>
                                    <div className="w-full my-5">
                                        <PasswordInput
                                            label="Password"
                                            name="Password"
                                            isRequired={true}
                                            // minLength={3}
                                            // maxLength={10}
                                            register={register}
                                            errors={errors}
                                            setValue={setValue}
                                            handleSteps={(e) => handleSteps(e, 'Password')} 
                                        />										
                                    </div>
                                    <div className="w-full my-5 flex flex-row justify-between mx-3">
                                        <label className="inline-flex items-center cursor-pointer">
                                            <input
                                                id="customCheckLogin"
                                                type="checkbox"
                                                className="form-checkbox"
                                            />
                                            <span className="ml-2 text-md text-black">
                                                Remember me
                                            </span>
                                        </label>
                                        <div className="mr-4">
                                            <a
                                                href="#pablo"
                                                onClick={(e) => { handleForgotPassword(e) }}
                                                className="text-yellow-500 text-xl"
                                            >
                                                <small>Forgot password?</small>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="text-center mt-6">
                                    <button
                                                type="submit"
                                                disabled={isLoading}
                                                className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                                    } flex-row flex items-center justify-center text-white text-xl p-4 w-full h-11`}
                                            >
                                                Login
                                                <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                                    <RotatingLines
                                                        visible={true}
                                                        width={'20'}
                                                        strokeColor="#fff"
                                                        strokeWidth="6"
                                                        animationDuration="0.75"
                                                        ariaLabel="rotating-lines-loading"
                                                    />
                                                </div>
                                            </button>


                                    </div>
                                    <div className="flex flex-row mt-6 bg-[#FAFAFA] justify-center items-center w-full">
                                        <img src={require('./../../assets/img/google.jpeg')} className="h-6 w-6" />

                                        <button
                                            className=" text-black text-opacity-50 text-xl p-2"
                                            type="button"
                                            onClick={() => startGoogleAuthentication()}
                                        >
                                            Sign In with Google
                                        </button>
                                    </div>
                                    <div className="w-full flex flex-row justify-center my-3 text-md text-black text-opacity-50">
                                        <div>Don't have any account ? </div>
                                        <div className="font-normal text-black text-opacity-100 hover:cursor-pointer"> &nbsp;<a onClick={() => handleRegistration()}>SignUp Free</a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-1/2 h-screen  flex justify-center items-center px-20">
                            <img src={require('../../assets/img/cart.png')} />
                        </div>
                    </div>
                </div>
            </div >
        </form >
        
        </>
    );
}
